import { useMemo } from 'react';
import { useOutletContext } from 'react-router-dom';
import { MarketList } from '../components/market/MarketList';
import { BonusPoolPromoBanner } from '../components/bonus/BonusPoolPromoBanner';
import { useMarketContext } from '../contexts/MarketContext';

export default function HomePage() {
  const { searchQuery, activeFilter } = useOutletContext();
  const { markets, predictions, loading } = useMarketContext();

  const filteredMarkets = useMemo(() => {
    let result = [...markets];

    // Filter by status
    if (activeFilter !== 'all') {
      result = result.filter((m) => m.status === activeFilter);
    }

    // Filter by search
    if (searchQuery) {
      const q = searchQuery.toLowerCase();
      result = result.filter(
        (m) =>
          m.teamA?.toLowerCase().includes(q) ||
          m.teamB?.toLowerCase().includes(q)
      );
    }

    // Sort: ended last, others by game time (earliest first)
    result.sort((a, b) => {
      // Ended markets go to the end
      if (a.status === 'ended' && b.status !== 'ended') return 1;
      if (a.status !== 'ended' && b.status === 'ended') return -1;
      
      // Both ended or both not ended: sort by game time
      const timeA = a.gameTime ? new Date(a.gameTime).getTime() : 0;
      const timeB = b.gameTime ? new Date(b.gameTime).getTime() : 0;
      return timeA - timeB;
    });

    return result;
  }, [markets, activeFilter, searchQuery]);

  return (
    <div className="space-y-5">
      <BonusPoolPromoBanner />
      <MarketList markets={filteredMarkets} predictions={predictions} loading={loading} />
    </div>
  );
}
